import { render, staticRenderFns } from "./GroupRevenueRank.vue?vue&type=template&id=47a41c32&scoped=true"
import script from "./GroupRevenueRank.vue?vue&type=script&lang=js"
export * from "./GroupRevenueRank.vue?vue&type=script&lang=js"
import style0 from "./GroupRevenueRank.vue?vue&type=style&index=0&id=47a41c32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a41c32",
  null
  
)

export default component.exports